import { render, staticRenderFns } from "./content-list.view.vue?vue&type=template&id=0f2d1040&"
import script from "./content-list.view.vue?vue&type=script&lang=ts&"
export * from "./content-list.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports